if (!customElements.get('cart-upsell-slider')) {
  customElements.define(
    'cart-upsell-slider',
    class CartUpsellSlider extends HTMLElement {
      static INIT_DELAY = 150;

      constructor() {
        super();

        this.initialized = false;
        this.swiperInstance = null;
        this.drawerObserver = null;
        this.initTimeout = null;
      }

      connectedCallback() {
        // Guard: prevent re-init if already set up (e.g. Shopify Theme Editor re-inserts the element)
        if (this.initialized) return;

        const cartDrawer = document.querySelector('.js-drawer');
        if (!cartDrawer) return;

        // If drawer is already open when element connects, schedule init immediately
        if (cartDrawer.classList.contains('active')) {
          this.scheduleInit();
          return;
        }

        // Otherwise observe for the first time drawer opens, then stop watching
        this.drawerObserver = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (
              mutation.attributeName === 'class' &&
              cartDrawer.classList.contains('active')
            ) {
              this.scheduleInit();
              this.cleanupObserver();
              break;
            }
          }
        });

        this.drawerObserver.observe(cartDrawer, { attributes: true });
      }

      disconnectedCallback() {
        this.cleanupObserver();
        clearTimeout(this.initTimeout);
        this.initTimeout = null;
        this.destroySwiper();

        // Reset so a future re-connection can init cleanly
        this.initialized = false;
      }

      // ─── Private helpers ───────────────────────────────────────────────

      scheduleInit() {
        clearTimeout(this.initTimeout);
        this.initTimeout = setTimeout(() => this.initSwiper(), CartUpsellSlider.INIT_DELAY);
      }

      cleanupObserver() {
        if (this.drawerObserver) {
          this.drawerObserver.disconnect();
          this.drawerObserver = null;
        }
      }

      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initSwiper() {
        if (this.initialized) return;

        const sliderEl = this.querySelector('.js-cart-upsell-slider__meta');
        if (!sliderEl) return;

        const slideCount = sliderEl.querySelectorAll('.swiper-slide').length;
        if (slideCount === 0) return;

        // Destroy any stale native Swiper instance before creating a new one
        if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);

        this.swiperInstance = new Swiper(sliderEl, {
          speed: DEFAULT_SLIDER_SPEED,
          slidesPerView: 2.7,
          spaceBetween: 8,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          watchOverflow: true,
          navigation: false,
          pagination: false,
          loop: slideCount > 4,
          updateOnWindowResize: true,
          breakpoints: {
            [DESKTOP_WIDTH]: {
              slidesPerView: 3.2,
            },
          }
        });

        this.initialized = true;
      }
    }
  );
}
